{ node, func, bool } = PropTypes

ItemWithCheckbox = createReactClass

  displayName: "ItemWithCheckbox"

  propTypes:
    onChange: func.isRequired
    children: node.isRequired
    checked: bool
    readonly: bool

  getDefaultProps: ->
    readonly: false
    checked: false

  onChange: (e) ->
    e.stopPropagation()
    @props.onChange(e)

  render: ->
    className = classNames 'item-with-checkbox', readOnly: @props.readonly , @props.className
    inputProps = if @props.readonly
      readOnly: true, checked: @props.checked
    else
      onChange: @onChange, checked: @props.checked

    <label className={className}>
      <span className="item-with-checkbox__checkbox">
        <input type="checkbox" {...inputProps} />
      </span>
      <span className="item-with-checkbox__item">
        {@props.children}
      </span>
    </label>

module.exports = ItemWithCheckbox
